import { z } from "zod";
import { optionalPasswordSchema, optionalUsernameSchema, usernameSchema } from "@/validations/login";

const baseUserSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, { message: "الاسم يجب أن يكون حرفين على الأقل" })
    .max(50, { message: "الاسم يجب أن يكون أقل من 50 حرف" }),
  username: usernameSchema,
  email: z
    .string()
    .trim()
    .min(1, { message: "البريد الإلكتروني مطلوب" })
    .email({
      message: "يجب أن يكون بريد إلكتروني صحيح",
    }),
  role: z.string().min(1, { message: "نوع الحساب غير صحيح" }).optional(),
  // Strapi department IDs are documentIds (not UUIDs).
  departmentId: z
    .string()
    .min(1, { message: "يجب اختيار دائرة صالحة" })
    .optional(),
  subAdminDepartmentIds: z.array(z.string()).optional(),
});

/** Admin create user: username/password optional — backend auto-generates when empty. */
const createUserSchema = baseUserSchema
  .omit({ username: true })
  .extend({
    username: optionalUsernameSchema.optional(),
    password: optionalPasswordSchema.optional(),
  });

const updateUserSchema = baseUserSchema
  .omit({ username: true })
  .extend({
    username: optionalUsernameSchema.optional(),
    password: optionalPasswordSchema.optional(),
    isActive: z.boolean().optional(),
  });

export const userSchema = createUserSchema;
export const createUserValidation = createUserSchema;
export const updateUserValidation = updateUserSchema;

export type UserSchemaType = z.infer<typeof userSchema>;
